//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan'
export default {
  name: "sup-ass-read",
  props: ['dataId','dataImg'],
  components:{
    DivSpan
  },
  data(){
    return{
      supAssFlow: {},
      index: 1,
      gridList: [
        {icon:require('@/assets/icon/supplier/supplier_base_data.png'),label:'基本信息'},
        {icon:require('@/assets/icon/supplier/bidding_detail.png'),label:'考核评分'},
        {icon:require('@/assets/icon/supplier/com_order_flow.png'),label:'流程信息'},
      ],
      supList:[],
      selectorSupNum:0,
      scoreIndex:0,
      approvalDetailObj:{}
    }
  },
  methods:{
    getBaseDto(){
      this.$loadingShow();
      this.$get(`api/sup-ass-flow/${this.dataId}`).then((data) => {
        if(data){
          this.supAssFlow = data;
          this.supAssFlow['periodType'] = data.supAssResults[0].periodType;
          this.supAssFlow['belongYear'] = data.supAssResults[0].belongYear;
          this.supAssFlow['belong'] = data.supAssResults[0].belong;
          for(let i = 0;i < this.supAssFlow.supAssResults.length;i++){
            let obj = {
              num:i,
              supName:this.supAssFlow.supAssResults[i].supplierName
            }
            this.supList.push(obj);
          }
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    itemTab(index) {
      this.index = index;
      if(index === 3){
        this.$emit('changeFlowInfo',true);
      }else{
        this.$emit('changeFlowInfo',false);
      }
    },
    //切换评分项
    scoreIndexChange(index){
      this.scoreIndex = index;
      if(index === 2 && this.supAssFlow.supAssResults[this.selectorSupNum]){
        this.approvalDetailObj = this.supAssFlow.supAssResults[this.selectorSupNum];
        this.$get(`api/sup-ass-task/${this.approvalDetailObj.supAssTaskId}`).then((res) => {
          if(res){
            this.approvalDetailObj.supAssTaskDto = res;
          }
        })
      }
    },
    //切换供应商
    supChange(e){
      this.scoreIndex = 0;
    },
    indexOf(str,par){
      if(!str){
        str = '';
      }
      return str.indexOf(par) != -1;
    },
    valid(){
      return true;
    },
    formData(){
      return this.supAssFlow;
    }
  },
  mounted(){
    if(this.dataId){
      this.getBaseDto();
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier-assess/sup-ass-read.vue